export const saveInteraction = async ({ action = "landing_click", email = null, recaptcha_score = null } = {}) => {
  try {
    // JSON body, never query parameters: actions can carry an e-mail address,
    // and personal data must not travel in request URLs (Webflow Marketplace).
    const body = { action, recaptcha_score: 1 };
    if (email) body.email = email;

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}interaction`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    await response.json();
  } catch (err) {
    console.error("Interaction save failed", err);
  }
};
